<template>
    <a :href="getLink" target="_blank">{{ formatted['contractName'] || formatted['symbolName'] }}</a>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
    raw: Object,
    formatted: Object,
    label: String,
});

const getLink = computed(() => {
    return 'https://www.barchart.com/quotes/' + props.formatted.symbol + '/interactive-chart';
    // return 'https://www.barchart.com/quotes/' + props.formatted.symbol;
});
</script>
